import { 
// AccountRegistrationColumns,
// AccountRegistrationData,
accountRegistrationEntityName, registerAccountFunctionDef, } from '../../../../../backend/features/accounts/shared';
import { AccountSectionComponent, useAccountSections } from '../../../../../ui/features/accounts';
import { useContactManagementTranslation } from '../../../../../ui/hooks/useContactManagementTranslation';
import { useTypedAnonymousPlatformFunctionCM } from '../../../../../ui/hooks/useTypedAnonymousPlatformFunction';
import { FullScreenWizard } from '@juvare/common-form-ui/FullScreenWizard';
import { showAlertDialog, showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router';
import publicRegistrationImage from '../../../../assets/publicRegistrationImage.svg';
export const PublicSelfRegistration = (props) => {
    var _a;
    const { t } = useContactManagementTranslation();
    const navigationContext = React.useContext(NavigationContext);
    const navigate = useNavigate();
    const registerAccount = useTypedAnonymousPlatformFunctionCM(registerAccountFunctionDef, props.app, accountRegistrationEntityName);
    const [changed, setChanged] = React.useState(false);
    const steps = ((_a = useAccountSections('public-registration').data) !== null && _a !== void 0 ? _a : []).map((section) => ({
        label: section.columns.title,
        render: (props) => React.createElement(AccountSectionComponent, Object.assign({ section: section, page: 'public-registration' }, props)),
    }));
    const handleChanged = React.useCallback((changed) => {
        if (changed) {
            navigationContext.setChanged(t('common.confirmWizardClose'));
        }
        else {
            navigationContext.clearChanged();
        }
        setChanged(changed);
    }, [t, navigationContext]);
    const handleBack = React.useCallback(() => {
        if (changed) {
            showConfirmDialog({
                title: t('common.confirmWizardClose'),
                confirmLabel: t('common.closeWizardWithoutSaving'),
                onConfirm: () => {
                    navigationContext.clearChanged();
                    navigate('/');
                },
            });
        }
        else {
            navigationContext.navigate(() => navigate('/'));
        }
    }, [t, navigationContext, navigate, changed]);
    //TODO create a separate interface to handle organization parameters when organizationsEnabled setting is disabled. Related Ticket: CNEO-1683
    const handleSubmit = React.useCallback((data) => {
        var _a, _b, _c, _d;
        const savePromise = registerAccount(Object.assign(Object.assign({}, data), { firstName: (_a = data.firstName) !== null && _a !== void 0 ? _a : '', lastName: (_b = data.lastName) !== null && _b !== void 0 ? _b : '', orgRole: (_c = data.orgRole) !== null && _c !== void 0 ? _c : {}, orgStatus: (_d = data.orgStatus) !== null && _d !== void 0 ? _d : {} })).catch((error) => {
            if (error.message && error.message.includes('not-unique-email')) {
                error.message = t('registration.userAlreadyExists');
            }
            throw error;
        });
        navigationContext.save(savePromise);
        return savePromise;
    }, [registerAccount, navigationContext, t]);
    const handleSubmitSuccess = React.useCallback(() => {
        showAlertDialog({
            title: (React.createElement(React.Fragment, null,
                React.createElement(Typography, { sx: { mb: 2 }, variant: 'h5' }, t('publicSelfRegistration.registrationSuccessful')),
                React.createElement(Typography, null, t('publicSelfRegistration.followInstructions')))),
            onClose: () => navigate('/'),
        });
    }, [navigate, t]);
    const getFullScreenWizardImage = () => {
        if (props.image) {
            return props.image;
        }
        if (!props.imageComponent) {
            return { src: publicRegistrationImage, alt: 'Public registration' };
        }
        return undefined;
    };
    if (steps && steps.length > 0) {
        return (React.createElement(FullScreenWizard, { steps: steps, title: t('forms.publicRegistration.title'), image: getFullScreenWizardImage(), imageComponent: props.imageComponent, open: true, onChanged: handleChanged, onCancel: handleBack, onSubmit: handleSubmit, onSubmitSuccess: handleSubmitSuccess }));
    }
    else {
        return null;
    }
};
